/* less-typografie.js · 12.10.2026 (David)
   Typografie für alle sichtbaren Texte, ohne die Inhalte selbst zu ändern:
   1. Less-Produktnamen brechen nicht um (Span mit white-space: nowrap; ein geschütztes Leerzeichen
      wäre in der Futura doppelt so breit wie ein normales).
   2. Zwischen Zahl und Einheit (100 %, 26 ml, 20 Min., 5 €, 600 Tropfen …) steht ein schmales
      geschütztes Leerzeichen (U+202F). Nur vorhandene Leerzeichen werden ersetzt.
   Bearbeitet nur Textknoten – alt-, title- und andere Attribute bleiben unberührt. */
(function () {
  var NAME = /Less (?:Face Oil(?: (?:Light|Plus))?|Cleansing Clay|Cleansing Set|Bowl|Scoop|Container)(?![A-Za-zÄÖÜäöüß])/g;
  var UNIT = /(\d)[  ](?=(?:%|ml|mg|g|kg|cm|mm|m|km|Min\.|Minuten|min|minutes|Std\.|Stunden|hours|h|°C|€|Tropfen|drops|Tage|Tagen|days|Wochen|weeks|Monate|Monaten|months|Jahre|Jahren|years)(?![A-Za-zÄÖÜäöüß]))/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, CODE: 1, PRE: 1, TEMPLATE: 1, TITLE: 1 };

  function wrapNames(node) {
    var text = node.nodeValue;
    NAME.lastIndex = 0;
    if (!NAME.test(text)) return;
    var parent = node.parentNode;
    if (parent.classList && (parent.classList.contains('less-nobr') || parent.classList.contains('less-typo'))) return;
    // Eine gemeinsame Hülle, damit der Text in Flex-Zeilen (z. B. Akkordeon-Fragen) ein Stück bleibt
    var frag = document.createElement('span');
    frag.className = 'less-typo';
    var last = 0, m;
    NAME.lastIndex = 0;
    while ((m = NAME.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      var span = document.createElement('span');
      span.className = 'less-nobr';
      span.textContent = m[0];
      frag.appendChild(span);
      last = m.index + m[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    parent.replaceChild(frag, node);
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) root = root.parentNode;
    if (!root || root.nodeType !== 1 || SKIP[root.nodeName] || root.isContentEditable) return;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        for (var p = n.parentNode; p && p !== root.parentNode; p = p.parentNode) {
          if (SKIP[p.nodeName] || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        }
        return /\d|Less /.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [], n;
    while ((n = tw.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      var v = t.nodeValue.replace(UNIT, '$1 ');
      if (v !== t.nodeValue) t.nodeValue = v;
      wrapNames(t);
    });
  }

  function start() {
    walk(document.body);
    // Nachgeladene Inhalte (Warenkorb, Schnellkauf, Filter) ebenfalls bearbeiten
    var obs = new MutationObserver(function (records) {
      obs.disconnect();
      records.forEach(function (r) {
        if (r.type === 'characterData') walk(r.target);
        r.addedNodes.forEach(function (a) { walk(a); });
      });
      obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
